<template>
    <!-- <div class="news-form"> -->
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="what">¿Qué Pasó?</label><small>(Describa lo ocurrido)</small>
                    <textarea name="what" id="what" cols="30" rows="2" class="form-control" v-model.trim="note.what" @input="$emit('input', content)"></textarea>
                    <span v-if="$v.note.what.$error" class="field-error">Debe responder la pregunta</span>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="who">¿Quien lo hizo o sobre quien ocurrió?</label>
                    <textarea name="who" id="who" cols="30" rows="2" class="form-control" v-model.trim="note.who" @input="$emit('input', content)"></textarea>
                    <span v-if="$v.note.who.$error" class="field-error">Debe responder la pregunta</span>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label for="how">¿Cómo Sucedió?</label>
                    <textarea name="how" id="how" cols="30" rows="2" class="form-control" v-model.trim="note.how" @input="$emit('input', content)"></textarea>
                    <span v-if="$v.note.how.$error" class="field-error">Debe responder la pregunta</span>
                </div>
            </div>
        </div>
    <!-- </div> -->
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    export default {
        props: {
            onSuccess: {
                type: Function
            },
            onError: {
                type: Function
            }
        },
        data() {
            return {
                note: {
                    what: '',
                    who: '',
                    how: '',
                }
            }
        },
        validations: {
            note: {
                what: { required },
                who: { required },
                how: { required },
            }
        },
        methods: {
            cleanFields(){
                Object.keys(this.note).map(key => this.note[key] = '');
                this.$v.$reset();
                this.$bus.$on('note-form-news.clean', this.cleanFields);
            },
            saveNote(){
                this.$v.$touch();

                if(this.$v.$invalid){
                    alert('Debe diligenciar los campos obligatorios');
                }
            },
            isValid(){
                this.$v.$touch();
                return !this.$v.$invalid;
            }
        },
        computed: {
            content(){
                return `\nQue: ${this.note.what}
                        \nQuien: ${this.note.who}
                        \nComo: ${this.note.how}`;
            
            }
        },
        created() {
            this.cleanFields();
        }
    }
</script>